import { z } from "zod";
import { baseSearchSchema, navigationSearchSchema } from "../-search-params";

export const resultsSearchSchema = z.object({
	...baseSearchSchema.shape,
	...navigationSearchSchema.shape,
});

export type ResultsSearch = z.infer<typeof resultsSearchSchema>;

export const validateResultsSearch = (search: Record<string, unknown>): ResultsSearch => {
	return resultsSearchSchema.parse(search);
};
